import {useEffect, useRef} from "react";
import EditorJS from "@editorjs/editorjs";
import {useDispatch, useSelector} from "react-redux";
import {setBlogCreateData, tryLoadBlogDetail} from "../../../redux/slices/manageBlogSlice";
import {editorJsConfig} from "../editorJsConfig";
import {CustomSpinner} from "../../../components/CustomSpinner";
import {ComponentError} from "../../../components/ComponentLoader";
import {DEFAULT_BLOG_INITIAL_DATA} from "../constants";

export default function BlogCanvas({blogId}) {

  const {loading, init, error, data} = useSelector((state) => state.manageBlogs.create.details);

  const dispatch = useDispatch();

  const _retryGetDetails = () => {
    dispatch(tryLoadBlogDetail({id: blogId}));
  };

  useEffect(() => {
    if (data?.title) {
      dispatch(setBlogCreateData({title: data?.title}));
    }

  }, [data]);



  return (

    <div className="px-16 py-4 blogs">
      {error ? <ComponentError retry={_retryGetDetails} errorMsg={error}/> : (init && !loading) || !blogId ?
        <_BlogCanvas data={blogId ? data.data : DEFAULT_BLOG_INITIAL_DATA} title={data.title}/> :
        <div className="flex items-center justify-center h-72 text flex-col">
          <CustomSpinner/>
          <div className="mt-5">Please wait... Loading contents.</div>
        </div>
      }

    </div>

  );

}

export function _BlogCanvas({data, title}) {

  const ejInstance = useRef();

  const initEditor = () => {
    const editor = new EditorJS({
      holder: 'blogCanvas',
      onReady: () => {
        ejInstance.current = editor;
      },
      autofocus: true,
      data: data,
      onChange: async () => {
        try {
          let content = await editor.saver.save();
          dispatch(setBlogCreateData({content}));
        } catch (e) {

        }

      },
      tools: editorJsConfig()
    });

  };


  useEffect(() => {
    if (!ejInstance.current) {
      initEditor();
    }

    return () => {
      ejInstance?.current?.destroy();
      ejInstance.current = null;
    };
  }, []);

  const dispatch = useDispatch();

  return (
    <>
      <_BlogTitle data={data} initialTitle={title}/>
      <div id="blogCanvas"/>
    </>
  );
}

const _BlogTitle = ({initialTitle}) => {

  // const title = useSelector((state => state.manageBlogs.create.mainTitle));

  const divEditableRef = useRef();

  useEffect(() => {
    if (initialTitle)
      divEditableRef.current.innerText = initialTitle;
  }, []);

  const dispatch = useDispatch();

  const onDataInput = (e) => {
    dispatch(setBlogCreateData({title: e.currentTarget.textContent}));
  };

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      e.preventDefault();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();

    // Get the copied text from the clipboard
    const text = e.clipboardData
      ? (e.originalEvent || e).clipboardData.getData('text/plain')
      : // For IE
      window.clipboardData
        ? window.clipboardData.getData('Text')
        : '';

    const _textNoEnter = text.replace(/(\r\n|\n|\r)/gm, " ");

    if (document.queryCommandSupported('insertText')) {
      document.execCommand('insertText', false, _textNoEnter);
    } else {
      // Insert text at the current position of caret
      const range = document.getSelection().getRangeAt(0);
      range.deleteContents();

      const textNode = document.createTextNode(_textNoEnter);
      range.insertNode(textNode);
      range.selectNodeContents(textNode);
      range.collapse(false);

      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    }
  };

  return (
    <div className="blog-width">
      {/*<Input className="border-none outline-none py-10 text-5xl mb-6 font-medium pl-0 bg-transparent" placeholder="Title Here" hasLabel={false} value={title} hideError={true}*/}
      {/*      onChange={(e) => dispatch(setBlogCreateData({title: e.target.value}))}/>*/}
      <div
        ref={divEditableRef}
        onInput={onDataInput}
        onPaste={handlePaste}
        onKeyDown={onKeyDown}
        contentEditable={true} placeholder="Title Here"
        className="border-none outline-none py-10 text-5xl mb-6 font-medium pl-0"/>
    </div>
  );
};



